import MotorParseable from "./class.MotorParseable";

export default class SelectGraph extends MotorParseable {
	hasClearButtonDefault() {
		return true;
	}

	isClearButtonEnabled() {
		return this.numSelected > 0;
	}

	constructor(options) {
		super(options);

		this.numSelected = 0;
	}

	getNewDriver() {
		return new Motors.Drivers.SelectGraphDriver();
	}

	getStartSignal() {
		// Parse graphElements (array of GraphElement objects).
		let graphElements = (this.model.graphElements || []).map((pE) => {
			let ret = {
				type: pE.elType || "polynomial",
				eqnData: this.tryJSONParse(pE.eqnData || []).map((v) => parseFloat(v)),
			};
			let options = [
				{name: "minDom", type: "number"},
				{name: "maxDom", type: "number"},
				{name: "isInverted", type: "boolean"},
				{name: "width", type: "number"},
				{name: "color", type: "string"},
			];
			options.forEach((opt) => {
				if (pE.hasOwnProperty(opt.name)) {
					ret[opt.name] =
						opt.type === "number" ? parseFloat(pE[opt.name]) : pE[opt.name];
				}
			});
			return ret;
		});

		// Note: for now, selectable types are restricted to "latts" and "elems",
		// not "both", for output.
		let selectableTypes = "elems"; // Default.
		if (this.model.selectableTypes === "lattice_points") {
			selectableTypes = "latts";
		}

		let multiSelectLimit =
			this.model.multiSelectLimit === undefined
				? 1
				: parseInt(this.model.multiSelectLimit);

		let selectedElemIndices = this.driverOutputs.selectedElemIndices || [];
		let selectedLattIndices = this.driverOutputs.selectedLattIndices || [];

		// Extract data to initialize coordinate plane.
		let bounds = this.tryJSONParse(this.model.graphBounds || "[]");
		let [minX, maxX, minY, maxY] = [-10, 10, -5, 5];
		if (!Array.isArray(bounds) || bounds.length < 4) {
			console.log(
				"Error in Graph Bounds input, need four entries.  Using defaults [-10, 10, -5, 5]."
			);
		} else {
			[minX, maxX, minY, maxY] = bounds;
		}
		let tickSizes = this.tryJSONParse(this.model.tickSizes || "[]");
		let [tickStepX, tickStepY] = [-1, 1];
		if (!Array.isArray(tickSizes) || tickSizes.length < 2) {
			console.log(
				"Error in Tick Sizes input, need two entries.  Using defaults [-1, 1]."
			);
		} else {
			[tickStepX, tickStepY] = tickSizes;
		}

		return {
			graphElements,
			selectableTypes,
			multiSelectLimit,
			selectedElemIndices,
			selectedLattIndices,

			// Graph background
			graphBackground: {
				minX,
				maxX,
				minY,
				maxY,
				tickStepX,
				tickStepY,
				backgroundImage: this.model.backgroundImage,
			},
			width: this.model.width || 600,
		};
	}

	getCachedResponseSignal(data) {
		return {
			selectedElemIndices: data.selectedElemIndices.slice(),
			selectedLattIndices: data.selectedLattIndices.slice(),
		};
	}

	onRenderResponse($responseDiv) {
		let response = this.driverOutputs[this.answerKey] || [];
		this.numSelected = response.length;
		this.rerenderClearButton();

		let preview = this.driverOutputs[this.previewKey] || [];
		if (this.previewKey === "selectedLattCoords") {
			preview = preview.map((v) => "(" + v + ")").join(", ");
		}

		return new Promise((resolve) => {
			if (this.previewKey === "noPreview") {
			} else if (this.isResponseEmpty(response)) {
				$responseDiv.html("<em>No selections made.</em>");
			} else {
				$responseDiv.text(preview);
			}
			this.setSubmittable(!this.isResponseEmpty(response));
			resolve();
		});
	}
}
